/** @jsxImportSource @emotion/react */
import React, {useEffect} from 'react'
import { Form, Button, Spinner } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@emotion/react'
import { SelectField } from 'components/common/form'
import { isAdmin as getIsAdminUser, isQualityUser as getIsQualityUser } from 'selectors/user'
import { useSelector } from 'react-redux'

export const DealsValidationForm = ({ isLoading, onDelete, canChangeValidation, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isDisabled = isLoading || props.isSubmitting || Object.keys(props.touched).length === 0
  const hasError = Object.keys(props.errors).length > 0
  const isQualityUser = useSelector(getIsQualityUser)
  const isAdminUser = useSelector(getIsAdminUser)

  const internalModified = React.useCallback((value) => {
    props.values.InternalValidation.Changed = true
    props.values.InternalValidation.Status = Number(value)
  })

  const validationOptions =
      isQualityUser?
      [{label: "", value:""},
      {label: t('execution.transactionStatus.validatedInternal'), value:2},
      {label: t('execution.transactionStatus.invalidatedInternal'), value:3}] :
      isAdminUser ?
      [{label: "", value:""},
      {label: t('execution.transactionStatus.pending'), value:1}] :
      [{label: "", value:""},
      {label: t('execution.transactionStatus.validatedClient'), value:4},]
  
  return (
    <Form
      onSubmit={props.handleSubmit}
      css={{
        section: {
          display: 'grid',
          gridGap: 10,
          gridTemplateColumns: 'repeat(2, 1fr)',
          paddingTop: theme.spacing,
          paddingBottom: theme.spacing * 2,
        },
        footer: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '>*': {
            display: 'flex',
            justifyContent: 'flex-end',
            button: { marginLeft: '0.6rem' },
          },
        },
      }}
    >
      <hr />
      <section className='mt-4'>
      <SelectField
          label={t('execution.transactionView.internalValid')}
          options={validationOptions}
          name="InternalValidation.Status"
          disabled={!canChangeValidation}
          onChangeCustom={internalModified}
        />
      </section>
      <footer>
        <div>
          <Button type="submit" disabled={isDisabled || hasError}>
            {isLoading && <Spinner size="sm" style={{ marginRight: '.6rem' }} />}
            <span>{t('strategy.alertPopover.save')}</span>
          </Button>
        </div>
      </footer>
    </Form>
  )
}
